import { Spacing } from "@assets/style/appMuiTheme"
import { css, spacingClass, spacingVars } from "@assets/style/util/cssUtils"
import { DiscoText } from "@disco-ui"
import { DiscoTagSkeleton } from "@disco-ui/tag/DiscoTag"
import classNames from "classnames"
import classes from "./DiscoTableFilterTags.module.css"

export type DiscoTableFilterTagsProps = Spacing & {
  children: React.ReactNode
  isVisible: boolean
}

function DiscoTableFilterTags({
  children,
  isVisible,
  ...spacing
}: DiscoTableFilterTagsProps) {
  if (!isVisible) return null
  return (
    <div
      className={classNames(classes.filterTags, spacingClass())}
      style={spacingVars({
        ...spacing,
        marginBottom: spacing.marginBottom ?? spacing.margin ?? 1,
      })}
    >
      <DiscoText variant={"body-sm"} color={"text.secondary"}>
        {"Filter by: "}
      </DiscoText>
      {children}
    </div>
  )
}

export function DiscoTableFilterTagsSkeleton() {
  return (
    <div
      className={classes.filterTags}
      style={css({
        "--filter-tags-margin-top": 0,
        "--filter-tags-margin-bottom": 3,
      })}
    >
      <DiscoText variant={"body-sm"} color={"text.secondary"}>
        {"Filter by: "}
      </DiscoText>
      <DiscoTagSkeleton />
    </div>
  )
}

export default DiscoTableFilterTags
